/**
 * Rudraksha Calculator JavaScript
 * Handles form submission, zodiac/purpose-based recommendations, and result display
 */

document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('rudraksha-calculator');
  const tabs = document.querySelectorAll('.calc-tab');
  const methods = document.querySelectorAll('.calculator-form__method');

  // Rudraksha data by zodiac
  const zodiacData = {
    'aries': { mukhi: '3 Mukhi', planet: 'Mars (Mangal)', benefits: ['Confidence', 'Energy', 'Leadership', 'Removes Fear', 'Boosts Willpower'], description: '3 Mukhi Rudraksha is ruled by Mars and is ideal for Aries natives. It boosts confidence, removes lethargy, and helps overcome fear and depression.', handle: '3-mukhi-rudraksha' },
    'taurus': { mukhi: '6 Mukhi', planet: 'Venus (Shukra)', benefits: ['Love', 'Creativity', 'Prosperity', 'Artistic Abilities', 'Charm'], description: '6 Mukhi Rudraksha is blessed by Venus and perfect for Taurus. It enhances love, creativity, and brings material comforts and artistic abilities.', handle: '6-mukhi-rudraksha' },
    'gemini': { mukhi: '4 Mukhi', planet: 'Mercury (Budh)', benefits: ['Intelligence', 'Communication', 'Memory', 'Focus', 'Learning'], description: '4 Mukhi Rudraksha represents Mercury and suits Gemini natives. It enhances intelligence, improves communication skills, and sharpens memory.', handle: '4-mukhi-rudraksha' },
    'cancer': { mukhi: '2 Mukhi', planet: 'Moon (Chandra)', benefits: ['Emotional Balance', 'Relationships', 'Peace', 'Harmony', 'Unity'], description: '2 Mukhi Rudraksha is governed by Moon and ideal for Cancer. It brings emotional stability, harmonious relationships, and inner peace.', handle: '2-mukhi-rudraksha' },
    'leo': { mukhi: '5 Mukhi', planet: 'Jupiter (Guru)', benefits: ['Leadership', 'Success', 'Balance', 'Health', 'Confidence'], description: '5 Mukhi Rudraksha blessed by Jupiter is ideal for Leo natives. It brings balance, overall well-being, and enhances natural leadership qualities.', handle: '5-mukhi-rudraksha' },
    'virgo': { mukhi: '4 Mukhi', planet: 'Mercury (Budh)', benefits: ['Analytical Mind', 'Precision', 'Health', 'Clarity', 'Wisdom'], description: '4 Mukhi Rudraksha aligns with Mercury for Virgo. It enhances analytical abilities, precision in work, and supports overall health.', handle: '4-mukhi-rudraksha' },
    'libra': { mukhi: '6 Mukhi', planet: 'Venus (Shukra)', benefits: ['Harmony', 'Beauty', 'Relationships', 'Balance', 'Grace'], description: '6 Mukhi Rudraksha blessed by Venus is perfect for Libra. It brings harmony, appreciation for beauty, and balanced relationships.', handle: '6-mukhi-rudraksha' },
    'scorpio': { mukhi: '3 Mukhi', planet: 'Mars (Mangal)', benefits: ['Transformation', 'Courage', 'Intensity', 'Power', 'Protection'], description: '3 Mukhi Rudraksha ruled by Mars empowers Scorpio natives. It aids transformation, builds courage, and channels intensity positively.', handle: '3-mukhi-rudraksha' },
    'sagittarius': { mukhi: '5 Mukhi', planet: 'Jupiter (Guru)', benefits: ['Wisdom', 'Luck', 'Spiritual Growth', 'Fortune', 'Knowledge'], description: '5 Mukhi Rudraksha represents Jupiter and benefits Sagittarius. It brings wisdom, good fortune, and accelerates spiritual growth.', handle: '5-mukhi-rudraksha' },
    'capricorn': { mukhi: '7 Mukhi', planet: 'Saturn (Shani)', benefits: ['Discipline', 'Success', 'Stability', 'Wealth', 'Patience'], description: '7 Mukhi Rudraksha governed by Saturn suits Capricorn. It brings discipline, professional success, and financial stability.', handle: '7-mukhi-rudraksha' },
    'aquarius': { mukhi: '7 Mukhi', planet: 'Saturn (Shani)', benefits: ['Innovation', 'Humanitarianism', 'Progress', 'Freedom', 'Vision'], description: '7 Mukhi Rudraksha ruled by Saturn benefits Aquarius. It supports innovation, humanitarian goals, and progressive thinking.', handle: '7-mukhi-rudraksha' },
    'pisces': { mukhi: '5 Mukhi', planet: 'Jupiter (Guru)', benefits: ['Intuition', 'Compassion', 'Spirituality', 'Healing', 'Dreams'], description: '5 Mukhi Rudraksha blessed by Jupiter is ideal for Pisces. It enhances intuition, deepens compassion, and strengthens spirituality.', handle: '5-mukhi-rudraksha' }
  };

  // Rudraksha data by purpose
  const purposeData = {
    'wealth': { mukhi: '7 Mukhi', planet: 'Saturn (Shani)', benefits: ['Financial Growth', 'Business Success', 'Prosperity', 'Removes Obstacles', 'Abundance'], description: '7 Mukhi Rudraksha is blessed by Goddess Lakshmi and removes financial obstacles. It attracts wealth, success, and creates opportunities for material prosperity and business growth.', handle: '7-mukhi-rudraksha' },
    'love': { mukhi: '2 Mukhi', planet: 'Moon (Chandra)', benefits: ['Harmonious Relationships', 'Unity', 'Emotional Bond', 'Marriage', 'Partnership'], description: '2 Mukhi Rudraksha symbolizes the unity of Shiva and Parvati. It strengthens relationships, brings harmony between partners, and deepens emotional connections.', handle: '2-mukhi-rudraksha' },
    'health': { mukhi: '5 Mukhi', planet: 'Jupiter (Guru)', benefits: ['Physical Health', 'Mental Peace', 'Vitality', 'Blood Pressure', 'Immunity'], description: '5 Mukhi Rudraksha is the most versatile bead for health. It regulates blood pressure, calms the mind, and promotes overall physical and mental well-being.', handle: '5-mukhi-rudraksha' },
    'protection': { mukhi: '7 Mukhi', planet: 'Saturn (Shani)', benefits: ['Protection from Negativity', 'Removes Obstacles', 'Financial Security', 'Goddess Lakshmi', 'Success'], description: '7 Mukhi Rudraksha blessed by Goddess Lakshmi offers powerful protection. It removes obstacles, protects against negative energies, and attracts prosperity and success.', handle: '7-mukhi-rudraksha' },
    'career': { mukhi: '4 Mukhi', planet: 'Mercury (Budh)', benefits: ['Career Growth', 'Success', 'Recognition', 'Communication', 'Intelligence'], description: '4 Mukhi Rudraksha enhances communication, intelligence, and creativity for career success. It improves public speaking, helps in competitive exams, and brings professional recognition.', handle: '4-mukhi-rudraksha' },
    'peace': { mukhi: '5 Mukhi', planet: 'Jupiter (Guru)', benefits: ['Inner Peace', 'Stress Relief', 'Meditation', 'Calm Mind', 'Spiritual Growth'], description: '5 Mukhi Rudraksha calms the mind, reduces stress and anxiety. It is perfect for meditation, yoga practitioners, and those seeking mental peace and spiritual growth.', handle: '5-mukhi-rudraksha' }
  };

  // Initialize location autocomplete
  Calculator.initLocationAutocomplete(['calc-pob', 'calc-pob-purpose']);

  // Initialize tab switching
  Calculator.initTabs(tabs, methods, {
    dob: ['calc-dob', 'calc-dob-purpose'],
    tob: ['calc-tob', 'calc-tob-purpose'],
    pob: ['calc-pob', 'calc-pob-purpose']
  }, 'rudraksha');

  // Form submission
  form.addEventListener('submit', async function(e) {
    e.preventDefault();

    // Set button to loading state
    Calculator.setSubmitButtonState(true);

    // Get active method
    const activeMethod = document.querySelector('.calc-tab.active').dataset.method;

    // Collect form data for validation
    const formData = {
      name: document.getElementById('calc-name').value,
      phone: document.getElementById('calc-phone').value,
      email: document.getElementById('calc-email').value || 'leads@karmaveda.in',
      dob: activeMethod === 'birth'
        ? document.getElementById('calc-dob').value
        : document.getElementById('calc-dob-purpose').value,
      tob: activeMethod === 'birth'
        ? document.getElementById('calc-tob').value
        : document.getElementById('calc-tob-purpose').value,
      pob: activeMethod === 'birth'
        ? document.getElementById('calc-pob').value
        : document.getElementById('calc-pob-purpose').value
    };

    // Validate inputs
    const validationErrors = Calculator.validateInputs(formData);
    if (validationErrors.length > 0) {
      alert('Please fix the following errors:\n\n' + validationErrors.join('\n'));
      Calculator.setSubmitButtonState(false);
      return;
    }
    let result;
    let resultKey;

    if (activeMethod === 'birth') {
      const dob = document.getElementById('calc-dob').value;
      const pob = document.getElementById('calc-pob').value;
      if (!dob) {
        alert('Please enter your date of birth');
        Calculator.setSubmitButtonState(false);
        return;
      }
      if (!pob) {
        alert('Please enter your place of birth');
        Calculator.setSubmitButtonState(false);
        return;
      }
      resultKey = Calculator.getZodiac(new Date(dob));
      result = zodiacData[resultKey];
    } else {
      const purpose = document.querySelector('input[name="purpose"]:checked');
      const dob = document.getElementById('calc-dob-purpose').value;
      const pob = document.getElementById('calc-pob-purpose').value;
      if (!purpose) {
        alert('Please select a purpose');
        Calculator.setSubmitButtonState(false);
        return;
      }
      if (!dob) {
        alert('Please enter your date of birth');
        Calculator.setSubmitButtonState(false);
        return;
      }
      if (!pob) {
        alert('Please enter your place of birth');
        Calculator.setSubmitButtonState(false);
        return;
      }
      resultKey = purpose.value;
      result = purposeData[resultKey];
    }

    // Collect lead data
    const leadName = document.getElementById('calc-name').value;
    const leadPhone = document.getElementById('calc-phone').value;
    const leadEmail = document.getElementById('calc-email').value || 'leads@karmaveda.in';
    const leadDob = activeMethod === 'birth'
      ? document.getElementById('calc-dob').value
      : document.getElementById('calc-dob-purpose').value;
    const leadTob = activeMethod === 'birth'
      ? document.getElementById('calc-tob').value
      : document.getElementById('calc-tob-purpose').value;
    const leadPob = activeMethod === 'birth'
      ? document.getElementById('calc-pob').value
      : document.getElementById('calc-pob-purpose').value;

    // Submit lead
    Calculator.submitLead({
      name: leadName,
      phone: leadPhone,
      email: leadEmail,
      body: `Calculator Lead - Rudraksha Calculator
================================
Name: ${leadName}
Phone: ${leadPhone}
Email: ${leadEmail}
Date of Birth: ${leadDob}
Time of Birth: ${leadTob || 'Not provided'}
Place of Birth: ${leadPob}
Method: ${activeMethod}
Recommended Product: ${result.handle}`
    });

    try {
      // Fetch product from Shopify
      const response = await fetch('/products/' + result.handle + '.js');
      if (!response.ok) throw new Error('Product not found');
      const product = await response.json();

      // Add handle for URL
      product.handle = result.handle;

      // Build result card
      const resultsContainer = document.getElementById('rudraksha-result');
      resultsContainer.textContent = '';
      const card = Calculator.buildResultCard({
        badge: 'Recommended for You',
        product: product,
        subtitle: `Ruling Planet: ${result.planet}`,
        description: result.description,
        cardIndex: 0
      });
      resultsContainer.appendChild(card);

      // Track calculator result
      if (typeof window.trackCalculatorResult === 'function') {
        window.trackCalculatorResult('rudraksha', result.handle, resultKey);
      }

      // Initialize handlers
      Calculator.initThumbnailHandlers(resultsContainer);
      Calculator.initCartHandlers(resultsContainer, {
        calculatorType: 'rudraksha',
        productName: product.title,
        productId: product.id
      });

      // Show result, hide form
      document.querySelector('.calculator-page__form-section').style.display = 'none';
      document.getElementById('calculator-result').style.display = 'block';

      Calculator.setSubmitButtonState(false);

      // Scroll to result
      document.getElementById('calculator-result').scrollIntoView({ behavior: 'smooth', block: 'start' });

    } catch (error) {
      console.error('Error:', error);
      alert('Something went wrong. Please try again.');
      Calculator.setSubmitButtonState(false);
    }
  });
});
